import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';

import './styles.scss';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { getModel } from './selectors';
import * as actions from './actions';
import { GeneralTabs } from 'sharedComponents';
import { TrendKPIList } from '../TrendKPIList';
import { LimitConfigContainer } from '../../../../LimitConfigurationBeta';
import { EnergyRelatedSignalsList } from '../EnergyRelatedSignalsList';
import useUserCapability from 'sharedHooks/useUserCapability';
import { internalTabIDs } from './constants';

// Create badge component for signal counts - always visible
const SignalsBadge = ({ count }) => {
    return (
        <span className={`signals-count-badge ${count > 0 ? 'has-selection' : 'no-selection'}`}>
            {count}
        </span>
    );
};

SignalsBadge.propTypes = {
    count: PropTypes.number.isRequired
};

const InternalTabs = (props) => {
    const { asset, isInternalTabLimitActive, selectedEnergySignalsCount, selectedOperationalParametersCount, energyRelatedKPIsList, internalActiveTab } = props.model;
    const { t: translate } = useTranslation();
    const userCapabilityHelper = useUserCapability();
    const shouldPreferEnergyTab = userCapabilityHelper.hasOperationalParametersEnergyCapability() && energyRelatedKPIsList?.length > 0 && selectedEnergySignalsCount > 0 && selectedOperationalParametersCount === 0;
    const [defaultInternalTab, setDefaultInternalTab] = useState(() => shouldPreferEnergyTab ? internalTabIDs.energyRelatedSignals : internalTabIDs.operationalParameters);

    const operationalTabTitle =
        <span className='tab-title-with-badge' id='operational-tab-title'>
            {translate('ABB.Powertrain.Frontend.detailedInformationOperationalParametersTabV2')}
            <SignalsBadge count={selectedOperationalParametersCount} />
        </span>;

    const energyTabTitle =
        <span className='tab-title-with-badge' id='energy-tab-title'>
            {translate('ABB.Powertrain.Frontend.EnergyConsumptionTab')}
            <SignalsBadge count={selectedEnergySignalsCount} />
        </span>;

    // Build tabs options conditionally
    const tabOptions = {
        operationalParameters: {
            title: operationalTabTitle,
            component: isInternalTabLimitActive ? <LimitConfigContainer asset={asset} /> : <TrendKPIList asset={asset} />
        }
    };
    if (userCapabilityHelper.hasOperationalParametersEnergyCapability() && energyRelatedKPIsList?.length > 0) {
        tabOptions.energyRelatedSignals = {
            title: energyTabTitle,
            component: isInternalTabLimitActive ? <LimitConfigContainer asset={asset} /> : <EnergyRelatedSignalsList asset={asset} />
        };
    }

    useEffect(() => {
        if (shouldPreferEnergyTab) {
            setDefaultInternalTab(internalTabIDs.energyRelatedSignals);
        }
    }, [shouldPreferEnergyTab]);

    return (
        <div className='internal-tabs-operational-parameters' id='internal-tabs-op'>
            <GeneralTabs
                options={tabOptions}
                defaultTab={internalActiveTab || defaultInternalTab}
            />
        </div>
    );
};
InternalTabs.propTypes = {
    model: PropTypes.shape({
        asset: PropTypes.object,
        isInternalTabLimitActive: PropTypes.bool,
        selectedEnergySignalsCount: PropTypes.number,
        selectedOperationalParametersCount: PropTypes.number,
        energyRelatedKPIsList: PropTypes.array,
        internalActiveTab: PropTypes.string,
    }),
    actions: PropTypes.object,
};
const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...actions }, dispatch)
    };
};

const InternalTabsContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(InternalTabs);

export default InternalTabsContainerConn;
